import { Component} from '@angular/core';
import { LoaderService } from 'src/app/shared/loader/loader.service';

@Component({
    selector: 'app-redirect-store',
    imports: [],
    templateUrl: './redirect-store.component.html',
    styleUrl: './redirect-store.component.scss'
})
export class RedirectStoreComponent {
  constructor( private loader:LoaderService,){

  }
  ngOnInit() {
    this.getMobileOS();
  }

  getMobileOS = () => {
    this.loader.showLoader();
    const userAgent = navigator.userAgent;
    if (/android/i.test(userAgent)) {
      window.location.href = 'https://www.financemutual.com/';
      setTimeout(function () {
        window.location.href =
          'https://play.google.com/store/apps/details?id=bhct.customer.financemutual';
      }, 1500);
    }
    // iOS detection covers iPad, iPhone, iPod (except for iPadOS 13+ in desktop mode)
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      // window.location.href = "https://recuvery.com/";
      window.location.href = 'https://www.financemutual.com/';
      // If app not installed, go to App Store after delay
      setTimeout(function () {
        window.location.href = 'https://apps.apple.com/us/app/financemutual-easy-pay/id6744879305';
      }, 1500);
      this.loader.hideLoader();
    }
    // return 'Other';
  };
}
